<h3 mat-dialog-title>{{ title | translate }}</h3>

<div mat-dialog-content>
  <div fxLayoutAlign="center center" class="mt-3 mb-3">
    <input #fileInput type="file" class="file-input" [multiple]="multiple" (change)="selectFiles($event)"
      accept="{{ extensions }}" />
    <button mat-raised-button color="sims" (click)="openFilesInput()" [disabled]="uploadInProgress">{{'selectFiles' |
      translate}}</button>
  </div>
  <ng-container *ngIf="selectedFiles?.length">
    <div fxLayout="column" class="pb-1" *ngFor="let progressInfo of progressInfos">
      <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="16px" class="mt-2">
        <div fxFlex="nogrow">{{ progressInfo.fileName }}</div>
        <div class="info">
          <span *ngIf="progressInfo.message" [ngClass]="progressInfo.error ? 'fail' : 'message'">{{ progressInfo.message }}</span>
          <span *ngIf="!progressInfo.error" class="progress ml-2">{{ progressInfo.value }}%</span>
        </div>
      </div>
      <div fxLayout="row" class="progress-bar-container mt-2">
        <mat-progress-bar mode="determinate" [value]="progressInfo.value"
          [color]="progressInfo.error ? 'fail' : 'progress'" fxFlexFill></mat-progress-bar>
      </div>

    </div>
  </ng-container>
</div>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="uploadedCount" [disabled]="uploadInProgress">{{ 'close' | translate }}</button>
</mat-dialog-actions>